import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { GetExploitationResponse, GetExploitationStatusCount, GetUserResponseLite } from 'src/app/services/dtos';
import {
	getDatesOfLastSevenDaysLabels,
	getDatesOfLastThirtyDaysLabels,
	getDatesOfLastTwelveMonthsLabels,
} from 'src/app/utils/date';
import departementsArray from 'src/app/utils/departements-region.json';
import {
	ChartColorPalette,
	ChartDisplayPeriod,
	ChartDisplayType,
	ChartLinearData,
	ChartLinearOptions,
	ChartOverviewPeriod,
	ChartPieData,
	ChartPieOptions,
	createLinearData,
	createLinearOptions,
	createPieData,
	createPieOptions,
	FilterOptionLabels,
	FilterPieOptions,
	getNumberOfCheptelForThe,
	getNumberOfTotalCheptelForThe,
	getNumberOfTotalUserForThe,
	getNumberOfUserForThe,
} from './chart-utils';

@Component({
	templateUrl: './chart-page.component.html',
	styleUrls: ['./chart-page.component.scss'],
	providers: [],
})
export class ChartPageComponent implements OnInit {
	paletteNeufCouleurs: string[] = [
		ChartColorPalette.OCEANBLUE,
		ChartColorPalette.CRIMSONRED,
		ChartColorPalette.SUNSHINEYELLOW,
		ChartColorPalette.TEALGREEN,
		ChartColorPalette.ROYALPURPLE,
		ChartColorPalette.TANGERINEORANGE,
		ChartColorPalette.SKYBLUE,
		ChartColorPalette.BUBBLEGUMPINK,
		ChartColorPalette.SLATEGRAY,
	];
	constructor(private apiService: ApiService) {}
	abonnementPieData: ChartPieData;
	abonnementPieOptions: ChartPieOptions;
	statusEnablePieData: ChartPieData;
	statusEnablePieOptions: ChartPieOptions;
	statusSynchroPieData: ChartPieData;
	statusSynchroPieOptions: ChartPieOptions;
	departementPieData: ChartPieData;
	departementPieOptions: ChartPieOptions;
	userCreatedLinearData: ChartLinearData;
	userCreatedLinearOptions: ChartLinearOptions;
	userTotalLinearData: ChartLinearData;
	userTotalLinearOptions: ChartLinearOptions;
	cheptelCreatedLinearData: ChartLinearData;
	cheptelCreatedLinearOptions: ChartLinearOptions;
	cheptelTotalLinearData: ChartLinearData;
	cheptelTotalLinearOptions: ChartLinearOptions;
	statusDatahubPieData: ChartPieData;
	statusDatahubPieOptions: ChartPieOptions;
	statusTbtPieData: ChartPieData;
	statusTbtPieOptions: ChartPieOptions;
	statusLotsPieData: ChartPieData;
	statusLotsPieOptions: ChartPieOptions;
	statusMedriaPieData: ChartPieData;
	statusMedriaPieOptions: ChartPieOptions;
	statusCount: GetExploitationStatusCount;
	users: GetUserResponseLite[];
	exploitations: GetExploitationResponse[];

	userCreatedOverviewPeriod: ChartOverviewPeriod[] = [
		{ period: ChartDisplayPeriod.WEEK, code: ChartDisplayType.WEEK },
		{ period: ChartDisplayPeriod.MONTH, code: ChartDisplayType.MONTH },
		{ period: ChartDisplayPeriod.YEAR, code: ChartDisplayType.YEAR },
	];
	userCreatedSelectedOverviewPeriod: ChartOverviewPeriod;

	cheptelCreatedOverviewPeriod: ChartOverviewPeriod[] = [
		{ period: ChartDisplayPeriod.WEEK, code: ChartDisplayType.WEEK },
		{ period: ChartDisplayPeriod.MONTH, code: ChartDisplayType.MONTH },
		{ period: ChartDisplayPeriod.YEAR, code: ChartDisplayType.YEAR },
	];
	cheptelCreatedSelectedOverviewPeriod: ChartOverviewPeriod;
	selectedMultiFiltrageOptionsFirstCard: FilterPieOptions[] = [
		{ label: FilterOptionLabels.SYNCHRONIZED, code: 'SYNCHRONIZED' },
	];
	selectedMultiFiltrageOptionsSecondCard: FilterPieOptions[] = [
		{ label: FilterOptionLabels.SYNCHRONIZED, code: 'SYNCHRONIZED' },
	];
	selectedMultiFiltrageStringFirstCard = 'Synchronisé';
	selectedMultiFiltrageStringSecondCard = 'Synchronisé';
	filtrageOptions: FilterPieOptions[] = [
		{ label: FilterOptionLabels.IDLE, code: 'IDLE' },
		{ label: FilterOptionLabels.SYNCHRONIZED, code: 'SYNCHRONIZED' },
		{ label: FilterOptionLabels.SCHEDULED, code: 'SCHEDULED' },
	];
	minimumCheptelTreshold = 1;
	maximumLabels = 7;
	ngOnInit() {
		this.apiService.exploitation_getStatusCounts().subscribe((response) => {
			this.statusCount = response;
			this.statusDatahubPieOptions = createPieOptions('Datahub');
			this.statusDatahubPieData = createPieData(
				['Oui', 'Non'],
				[
					this.statusCount.hasDatahubCount.synchronized,
					this.statusCount.exploitationCount.synchronized - this.statusCount.hasDatahubCount.synchronized,
				],
				this.paletteNeufCouleurs,
			);
			this.statusTbtPieOptions = createPieOptions('Tableau de bord troupeau');
			this.statusTbtPieData = createPieData(
				['Oui', 'Non'],
				[
					this.statusCount.hasTbtCount.synchronized,
					this.statusCount.exploitationCount.synchronized - this.statusCount.hasTbtCount.synchronized,
				],
				this.paletteNeufCouleurs,
			);
			this.statusLotsPieOptions = createPieOptions('Lots');
			this.statusLotsPieData = createPieData(
				['Oui', 'Non'],
				[
					this.statusCount.hasLotsCount.synchronized,
					this.statusCount.exploitationCount.synchronized - this.statusCount.hasLotsCount.synchronized,
				],
				this.paletteNeufCouleurs,
			);
			this.statusMedriaPieOptions = createPieOptions('Medria');
			this.statusMedriaPieData = createPieData(
				['Oui', 'Non'],
				[
					this.statusCount.hasMedriaCount.synchronized,
					this.statusCount.exploitationCount.synchronized - this.statusCount.hasMedriaCount.synchronized,
				],
				this.paletteNeufCouleurs,
			);
			// Le status de synchronisation n'est plus disponible au niveau de l'exploitation
			// Les données sont maintenant disponibles via statusCount uniquement
			this.statusSynchroPieData = createPieData(
				['Synchronisé', 'Non synchronisé', 'Plannifiée'],
				[
					this.statusCount.exploitationCount.synchronized,
					this.statusCount.exploitationCount.idle,
					this.statusCount.exploitationCount.scheduled,
				],
				this.paletteNeufCouleurs,
			);
			this.statusSynchroPieOptions = createPieOptions('Repartition par status de synchronisation');
		});
		this.apiService.exploitation_getUsers().subscribe((response) => {
			this.users = response.users;
			this.userCreatedLinearData = createLinearData(
				getDatesOfLastSevenDaysLabels(),
				'Utilisateurs créés',
				getNumberOfUserForThe(ChartDisplayType.WEEK, this.users),
			);

			this.userCreatedLinearOptions = createLinearOptions('Utilisateurs créés');
			this.userTotalLinearData = createLinearData(
				getDatesOfLastSevenDaysLabels(),
				'Utilisateurs',
				getNumberOfTotalUserForThe(ChartDisplayType.WEEK, this.users),
			);

			this.userTotalLinearOptions = createLinearOptions("Evolution du nombre d'utilisateurs");
		});
		this.apiService.exploitation_getAdminExploitations().subscribe((response) => {
			this.exploitations = response.exploitations;

			const offreAbonnementValues = ['PERFORMANCE', 'ESSENTIEL'];
			this.abonnementPieData = createPieData(
				['Performance', 'Essentiel'],
				offreAbonnementValues.map(
					(offreAbonnementValue) =>
						this.exploitations.filter(
							(exploitation) => exploitation.offreAbonnement === offreAbonnementValue,
						).length,
				),
				this.paletteNeufCouleurs,
			);
			this.abonnementPieOptions = createPieOptions("Cheptels par type d'abonnement");

			this.statusEnablePieData = createPieData(
				['Activé', 'Désactivé'],
				[
					this.exploitations.filter((exploitation) => exploitation.enabled === 'ENABLED').length,
					this.exploitations.filter((exploitation) => exploitation.enabled === 'DISABLED').length,
				],
				this.paletteNeufCouleurs,
			);
			this.statusEnablePieOptions = createPieOptions("Repartition par status d'activation");

			const numdepartementWithCheptels = departementsArray
				.filter(
					(departement) =>
						this.exploitations.filter(
							(exploitation) => exploitation.numeroCheptel.substring(0, 2) == departement.num_dep,
						).length >= this.minimumCheptelTreshold,
				)
				.map((obj) => obj.num_dep);
			const lengths = numdepartementWithCheptels.map((num_dep) => {
				return this.exploitations.filter(
					(exploitation) => exploitation.numeroCheptel.substring(0, 2) == num_dep,
				).length;
			});
			const labels = departementsArray
				.filter(
					(departement) =>
						this.exploitations.filter(
							(exploitation) => exploitation.numeroCheptel.substring(0, 2) == departement.num_dep,
						).length >= this.minimumCheptelTreshold,
				)
				.map((obj) => obj.dep_name);
			this.departementPieData = createPieData(labels, lengths, this.paletteNeufCouleurs);
			this.departementPieOptions = createPieOptions('Cheptels par departement');

			if (this.departementPieData.datasets[0].data.length > this.maximumLabels) {
				[this.departementPieData.datasets[0].data, this.departementPieData.labels] = this.pieLabelLimitation(
					this.departementPieData.datasets[0].data,
					this.departementPieData.labels,
				);
			}

			this.cheptelCreatedLinearData = createLinearData(
				getDatesOfLastSevenDaysLabels(),
				'Cheptels créés',
				getNumberOfCheptelForThe(ChartDisplayType.WEEK, this.exploitations),
			);
			this.cheptelCreatedLinearOptions = createLinearOptions('Cheptels créés');

			this.cheptelTotalLinearData = createLinearData(
				getDatesOfLastSevenDaysLabels(),
				'Cheptels',
				getNumberOfTotalCheptelForThe(ChartDisplayType.WEEK, this.exploitations),
			);
			this.cheptelTotalLinearOptions = createLinearOptions('Evolution du nombre de cheptels');
		});
	}

	changeUserOverviewPeriod() {
		const overviewPeriod = this.userCreatedSelectedOverviewPeriod.code;
		const dataFunc = {
			[ChartDisplayType.WEEK]: {
				created: {
					data: getNumberOfUserForThe(ChartDisplayType.WEEK, this.users),
					labels: getDatesOfLastSevenDaysLabels(),
				},
				total: {
					data: getNumberOfTotalUserForThe(ChartDisplayType.WEEK, this.users),
					labels: getDatesOfLastSevenDaysLabels(),
				},
			},
			[ChartDisplayType.MONTH]: {
				created: {
					data: getNumberOfUserForThe(ChartDisplayType.MONTH, this.users),
					labels: getDatesOfLastThirtyDaysLabels(),
				},
				total: {
					data: getNumberOfTotalUserForThe(ChartDisplayType.MONTH, this.users),
					labels: getDatesOfLastThirtyDaysLabels(),
				},
			},
			[ChartDisplayType.YEAR]: {
				created: {
					data: getNumberOfUserForThe(ChartDisplayType.YEAR, this.users),
					labels: getDatesOfLastTwelveMonthsLabels(),
				},
				total: {
					data: getNumberOfTotalUserForThe(ChartDisplayType.YEAR, this.users),
					labels: getDatesOfLastTwelveMonthsLabels(),
				},
			},
		};

		this.userCreatedLinearData.datasets[0].data = dataFunc[overviewPeriod].created.data;
		this.userCreatedLinearData.labels = dataFunc[overviewPeriod].created.labels;
		this.userTotalLinearData.datasets[0].data = dataFunc[overviewPeriod].total.data;
		this.userTotalLinearData.labels = dataFunc[overviewPeriod].total.labels;
	}

	changeExploitationOverviewPeriod() {
		const overviewPeriod = this.cheptelCreatedSelectedOverviewPeriod;
		const dataFunc = {
			[ChartDisplayType.WEEK]: {
				data: getNumberOfCheptelForThe(ChartDisplayType.WEEK, this.exploitations),
				labels: getDatesOfLastSevenDaysLabels(),
			},
			[ChartDisplayType.MONTH]: {
				data: getNumberOfCheptelForThe(ChartDisplayType.MONTH, this.exploitations),
				labels: getDatesOfLastThirtyDaysLabels(),
			},
			[ChartDisplayType.YEAR]: {
				data: getNumberOfCheptelForThe(ChartDisplayType.YEAR, this.exploitations),
				labels: getDatesOfLastTwelveMonthsLabels(),
			},
		};

		this.cheptelCreatedLinearData.datasets[0].data = dataFunc[overviewPeriod.code].data;
		this.cheptelCreatedLinearData.labels = dataFunc[overviewPeriod.code].labels;
		this.cheptelTotalLinearData.datasets[0].data = getNumberOfTotalCheptelForThe(
			overviewPeriod.code,
			this.exploitations,
		);
		this.cheptelTotalLinearData.labels = dataFunc[overviewPeriod.code].labels;
	}

	transformArray(arr: number[]): number[] {
		const sum = arr.reduce((acc, curr) => acc + curr, 0);
		const transformedArr = [
			...arr.slice(0, this.maximumLabels),
			sum - arr.slice(0, this.maximumLabels).reduce((acc, curr) => acc + curr, 0),
		];
		return transformedArr;
	}

	pieLabelLimitation(data: number[], label: string[]): [number[], string[]] {
		const indices = data.map((value, index) => index);
		indices.sort((a, b) => data[b] - data[a]);
		data = indices.map((index) => data[index]);
		label = indices.map((index) => label[index]);
		data = this.transformArray(data);
		label = label.splice(0, this.maximumLabels);
		label.push('Autres');
		return [data, label];
	}

	updateFilterFirstCard() {
		this.selectedMultiFiltrageStringFirstCard = this.selectedMultiFiltrageOptionsFirstCard
			.map((obj) => obj.label)
			.join(' + ');
		// Le filtrage par synchronizationStatus n'est plus disponible car la propriété a été supprimée
		// Les graphiques affichent maintenant toutes les exploitations sans filtrage par status
		const offreAbonnementValues = ['PERFORMANCE', 'ESSENTIEL'];
		this.abonnementPieData.datasets[0].data = offreAbonnementValues.map(
			(offreAbonnementValue) =>
				this.exploitations.filter((exploitation) => exploitation.offreAbonnement === offreAbonnementValue)
					.length,
		);

		const numdepartementWithCheptels = departementsArray
			.filter(
				(departement) =>
					this.exploitations.filter(
						(exploitation) => exploitation.numeroCheptel.substring(0, 2) == departement.num_dep,
					).length >= this.minimumCheptelTreshold,
			)
			.map((obj) => obj.num_dep);
		this.departementPieData.datasets[0].data = numdepartementWithCheptels.map((num_dep) => {
			return this.exploitations.filter((exploitation) => exploitation.numeroCheptel.substring(0, 2) == num_dep)
				.length;
		});
		this.departementPieData.labels = departementsArray
			.filter(
				(departement) =>
					this.exploitations.filter(
						(exploitation) => exploitation.numeroCheptel.substring(0, 2) == departement.num_dep,
					).length >= this.minimumCheptelTreshold,
			)
			.map((obj) => obj.dep_name);
		if (this.departementPieData.datasets[0].data.length > this.maximumLabels) {
			[this.departementPieData.datasets[0].data, this.departementPieData.labels] = this.pieLabelLimitation(
				this.departementPieData.datasets[0].data,
				this.departementPieData.labels,
			);
		}
	}

	updateFilterSecondCard() {
		this.selectedMultiFiltrageStringSecondCard = this.selectedMultiFiltrageOptionsSecondCard
			.map((obj) => obj.label)
			.join(' + ');
		const selectedStates = this.selectedMultiFiltrageOptionsSecondCard.map((obj) => obj.code);
		let sommeExploitation = 0;
		let sommeMedria = 0;
		let sommeTbt = 0;
		let sommeLots = 0;
		let sommeDatahub = 0;
		for (const val in selectedStates) {
			if (selectedStates[val] === 'IDLE') {
				sommeExploitation = sommeExploitation + this.statusCount.exploitationCount.idle;
				sommeMedria = sommeMedria + this.statusCount.hasMedriaCount.idle;
				sommeTbt = sommeTbt + this.statusCount.hasTbtCount.idle;
				sommeLots = sommeLots + this.statusCount.hasLotsCount.idle;
				sommeDatahub = sommeDatahub + this.statusCount.hasDatahubCount.idle;
			} else if (selectedStates[val] === 'SCHEDULED') {
				sommeExploitation = sommeExploitation + this.statusCount.exploitationCount.scheduled;
				sommeMedria = sommeMedria + this.statusCount.hasMedriaCount.scheduled;
				sommeTbt = sommeTbt + this.statusCount.hasTbtCount.scheduled;
				sommeLots = sommeLots + this.statusCount.hasLotsCount.scheduled;
				sommeDatahub = sommeDatahub + this.statusCount.hasDatahubCount.scheduled;
			} else if (selectedStates[val] === 'SYNCHRONIZED') {
				sommeExploitation = sommeExploitation + this.statusCount.exploitationCount.synchronized;
				sommeMedria = sommeMedria + this.statusCount.hasMedriaCount.synchronized;
				sommeTbt = sommeTbt + this.statusCount.hasTbtCount.synchronized;
				sommeLots = sommeLots + this.statusCount.hasLotsCount.synchronized;
				sommeDatahub = sommeDatahub + this.statusCount.hasDatahubCount.synchronized;
			}
		}
		this.statusDatahubPieOptions = createPieOptions('Datahub');
		this.statusDatahubPieData = createPieData(
			['Oui', 'Non'],
			[sommeDatahub, sommeExploitation - sommeDatahub],
			this.paletteNeufCouleurs,
		);
		this.statusTbtPieOptions = createPieOptions('Tableau de bord troupeau');
		this.statusTbtPieData = createPieData(
			['Oui', 'Non'],
			[sommeTbt, sommeExploitation - sommeTbt],
			this.paletteNeufCouleurs,
		);
		this.statusLotsPieOptions = createPieOptions('Lots');
		this.statusLotsPieData = createPieData(
			['Oui', 'Non'],
			[sommeLots, sommeExploitation - sommeLots],
			this.paletteNeufCouleurs,
		);
		this.statusMedriaPieOptions = createPieOptions('Medria');
		this.statusMedriaPieData = createPieData(
			['Oui', 'Non'],
			[sommeMedria, sommeExploitation - sommeMedria],
			this.paletteNeufCouleurs,
		);
	}
}
